module.exports = __webpack_public_path__ + "static/media/newsletter-december-2022-4.2d17c947.jpg";